import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  getProjectById,
  ProjectAPIResponse,
  ProjectTableData,
  transformProjectData,
  updateProjectById,
} from "../../../core/api/useProject";
import { Link } from "react-router-dom";
import CommonSelect from "../../../core/common/commonSelect";
import { DatePicker } from "antd";
import CommonTagsInput from "../../../core/common/Taginput";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CommonTextEditor from "../../../core/common/textEditor";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { API_BASE_PATH } from "../../../environment";
import { all_routes } from "../../router/all_routes";
import dayjs from "dayjs";
import { ClientListFormatted } from "../../../core/api/useClient";
import { fetchProjectEmployees } from "../../../core/api/useProjectMapping";
import Select from "react-select";
import { Modal } from 'bootstrap';
import { useTaskInfo } from "../../../core/api/useTaskInfo";
import AddTaskModal from "../task/AddTaskModal";
import { toast } from "react-toastify";

export type Option = {
  label: string;
  value: string;
};

const BASE_URL = API_BASE_PATH;
const MAX_FILE_SIZE_MB = 4;
const statusOptions = [
  { value: "Active", label: "Active" },
  { value: "Completed", label: "Completed" },
  { value: "Pending", label: "Pending" },
  { value: "Canceled", label: "Canceled" },
];

const priorityOptions: Option[] = [
  { value: "Critical", label: "Critical" },
  { value: "High", label: "High" },
  { value: "Medium", label: "Medium" },
  { value: "Low", label: "Low" },
];
const ProjectDetails = () => {
  const location = useLocation();
  const projectId = location.state?.Project?.ProjectID;
  const { Project, employeeMap, managerMapping, leaderMapping, memberMapping } =
    location.state || {};
  const memberTabRef = useRef<HTMLButtonElement>(null);
  const [imagePreview, setImagePreview] = useState<string>("");
  const [project, setProject] = useState<ProjectAPIResponse | null>(null);
  const formatDate = (dateStr: string): string => {
    if (!dateStr) return "N/A";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };
  const descriptionRef = useRef<any>(project?.description);
  const [transformed, setTransformed] = useState<ProjectTableData | null>(null);

  const { tasks, loading, error, refreshTasks } = useTaskInfo(projectId);
  useEffect(() => {
    if (project) {
      const transformedData = transformProjectData([project]);
      setTransformed(transformedData[0]);
    }
  }, [project]);


  const [clientList, setClientList] = useState<ClientListFormatted[]>([]);
  // Form states
  const [projectName, setProjectName] = useState("");
  const [clientId, setClientId] = useState("");
  const [projectType, setProjectType] = useState("");
  const [priority, setPriority] = useState("");
  const [statusVal, setStatusVal] = useState("");
  const [projectValue, setProjectValue] = useState("");
  const [priceType, setPriceType] = useState("");
  const [projectVersion, setProjectVersion] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [deadline, setDeadline] = useState("");
  const [remarks, setRemarks] = useState("");
  const [description, setDescription] = useState("");
  const [estimatedHours, setEstimatedHours] = useState("");
  const [totalHours, setTotalHours] = useState("");
  const [actualHours, setActualHours] = useState("");
  const [projectLogo, setProjectLogo] = useState<File | null>(null);
  const [uploadFile, setUploadFile] = useState<File | null>(null);

  const [employeeOptions, setEmployeeOptions] = useState<Option[]>([]);

  const [tags, setTags] = useState<string[]>([]);

  const projectMembers: string[] = Array.from(
    new Set(
      (Array.isArray(memberMapping) ? memberMapping.flat() : Object.values(memberMapping || {}))
        .flatMap((val) =>
          typeof val === "string" ? val.split(",").map((id) => id.trim()) : []
        )
        .filter(Boolean)
    )
  );

  const projectLeads: string[] = Array.from(
    new Set(
      (Array.isArray(leaderMapping) ? leaderMapping.flat() : Object.values(leaderMapping || {}))
        .flatMap((val1) =>
          typeof val1 === "string" ? val1.split(",").map((id) => id.trim()) : []
        )
        .filter(Boolean)
    )
  );

  const projectManagers: string[] = Array.from(
    new Set(
      (Array.isArray(managerMapping) ? managerMapping.flat() : Object.values(managerMapping || {}))
        .flatMap((val) =>
          typeof val === "string" ? val.split(",").map((id) => id.trim()) : []
        )
        .filter(Boolean)
    )
  );


  const [teamMembers, setTeamMembers] = useState<
    { label: string; value: string }[]
  >([]);
  const [teamLeader, setTeamLeader] = useState<
    { label: string; value: string }[]
  >([]);
  const [projectManager, setProjectManager] = useState<
    { label: string; value: string }[]
  >([]);


  // Fetch and populate project
  useEffect(() => {
    const fetchProjectDetails = async () => {
      if (!projectId) return;
      const data = await getProjectById(projectId);
      setProject(data);
    };
    fetchProjectDetails();
  }, [projectId]);
  useEffect(() => {
    fetchProjectEmployees()
      .then((employees) => {
        const options = employees.map((emp) => ({
          label: `${emp.username} Dep : ${emp.department} | Des : ${emp.designation}`,
          value: emp.employee_id,
        }));
        setEmployeeOptions(options);
      })
      .catch((err) => {
        console.error("Failed to fetch project employees", err);
      });
  }, []);

  useEffect(() => {
    if (!project) return;
    const transformed = transformProjectData([project])[0];

    setProjectName(project.project_name || "");
    setClientId(project.client_id || "");
    setProjectType(project.project_type || "");
    setPriority(project.priority || "");
    setStatusVal(project.status || "");
    setProjectValue(String(project.project_value || ""));
    setPriceType(project.price_type || "");
    setProjectVersion(project.project_version || "");
    setStartDate(project.start_date || "");
    setEndDate(project.end_date || "");
    setDeadline(project.deadline || "");
    setRemarks(project.remarks || "");
    setDescription(project.description || "");
    setEstimatedHours(String(project.estimated_hours || ""));
    setTotalHours(String(project.total_hours || ""));
    setActualHours(String(project.actual_hours || ""));

    setTags((project.tags || []).filter(Boolean) as string[]);
    setTeamMembers(
      transformed.ProjectMembers.map((id) => ({
        value: id,
        label: employeeOptions.find((emp) => emp.value === id)?.label || id,
      }))
    );

    setTeamLeader(
      transformed.ProjectLeads.map((v) => ({ value: v, label: v }))
    );
    setProjectManager(
      transformed.ProjectManagers.map((v) => ({ value: v, label: v }))
    );
  }, [project]);
  const handleEditSubmit = async () => {
    const formData = new FormData();

    formData.append("project_name", projectName);
    formData.append("client_id", clientId);
    formData.append("project_type", projectType);
    formData.append("priority", priority);
    formData.append("status", statusVal);
    formData.append("price_type", priceType);
    formData.append("project_value", projectValue);
    formData.append("project_version", projectVersion);
    formData.append("start_date", dayjs(startDate).format("YYYY-MM-DD"));
    formData.append("end_date", dayjs(endDate).format("YYYY-MM-DD"));
    formData.append("deadline", dayjs(deadline).format("YYYY-MM-DD"));

    formData.append("remarks", remarks);
    formData.append("description", description);
    formData.append("estimated_hours", estimatedHours);
    formData.append("total_hours", totalHours);

    formData.append("actual_hours", parseFloat(actualHours || "0").toString());
    formData.append("estimated_hours", parseFloat(estimatedHours || "0").toString());
    formData.append("total_hours", parseFloat(totalHours || "0").toString());
    formData.append("project_value", parseFloat(projectValue || "0").toString());
    formData.append("project_version", parseFloat(projectVersion || "0").toString());

    if (teamMembers.length)
      formData.append("project_member", teamMembers.map((m) => m.value).join(","));
    if (teamLeader.length)
      formData.append("project_lead", teamLeader.map((m) => m.value).join(","));
    if (projectManager.length)
      formData.append("project_manager", projectManager.map((m) => m.value).join(","));

    if (tags.length) formData.append("tags", tags.join(","));
    if (projectLogo) formData.append("logo", projectLogo);
    if (uploadFile) formData.append("upload_file", uploadFile);

    const result = await updateProjectById(projectId, formData);

    if (result) {
      const modalEl = document.getElementById("edit_project");
      if (modalEl) {
        const modalInstance = Modal.getInstance(modalEl);
        modalInstance?.hide();
      }
    }
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) backdrop.remove();

    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  };


  const handleSingleSelect =
    (setter: (val: string) => void) => (selected: unknown) => {
      if (selected) setter((selected as Option).value);
    };

  const handleMultiSelect =
    (setter: (val: Option[]) => void) => (selected: unknown) => {
      setter(selected as Option[]);
    };

  const handleLogoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Check file size
    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
            toast("Image should be below 4MB");
      return;
    }

    setProjectLogo(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result as string);
    };
    reader.readAsDataURL(file);
  };

  const handleCancel = () => {
    setProjectLogo(null);
    setImagePreview("");
  };

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };
  if (!project) return <p>Loading project details...</p>;

  const getBadgeClass = (status: string) => {
    switch (status.toLowerCase()) {
      case "onhold":
        return "bg-soft-pink";
      case "inprogress":
        return "bg-transparent-purple";
      case "completed":
        return "badge-soft-success";
      default:
        return "bg-light";
    }
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row align-items-center mb-4">
            <div className="d-md-flex d-sm-block justify-content-between align-items-center flex-wrap">
              <h6 className="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
                <Link to={all_routes.projectlist}>
                  <i className="ti ti-arrow-left me-2" />
                  Back to List
                </Link>
              </h6>
              <div className="d-flex">
                <div className="text-end">
                  <Link
                    to="#"
                    className="btn btn-primary"
                    data-bs-toggle="modal"
                    data-inert={true}
                    data-bs-target="#edit_project"
                  >
                    <i className="ti ti-edit me-1" />
                    Edit Project
                  </Link>
                </div>
                <div className="head-icons ms-2 text-end">
                  <CollapseHeader />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-3 col-xl-4 theiaStickySidebar">
              <div className="card">
                <div className="card-body">
                  <h5 className="mb-3">Project Details</h5>
                  <div className="list-group details-list-group mb-4">
                    <div className="list-group-item">
                      <span>Client</span>
                      <p className="text-gray-9">
                        {project.client_data?.username || "N/A"}
                      </p>
                    </div>
                    <div className="list-group-item">
                      <div className="d-flex align-items-center justify-content-between">
                        <span>Project Total Cost</span>
                        <p className="text-gray-9">
                          ${project.project_value ?? 0}
                        </p>
                      </div>
                    </div>
                    <div className="list-group-item">
                      <div className="d-flex align-items-center justify-content-between">
                        <span>Hours of Work</span>
                        <p className="text-gray-9">
                          {project.total_hours ?? 0} hrs
                        </p>
                      </div>
                    </div>
                    <div className="list-group-item">
                      <div className="d-flex align-items-center justify-content-between">
                        <span>Created on</span>
                        <p className="text-gray-9">
                          {formatDate(project.start_date)}
                        </p>
                      </div>
                    </div>
                    <div className="list-group-item">
                      <div className="d-flex align-items-center justify-content-between">
                        <span>Started on</span>
                        <p className="text-gray-9">
                          {formatDate(project.start_date)}
                        </p>
                      </div>
                    </div>
                    <div className="list-group-item">
                      <div className="d-flex align-items-center justify-content-between">
                        <span>Due Date</span>
                        <div className="d-flex align-items-center">
                          <p className="text-gray-9 mb-0">
                            {formatDate(project.deadline)}
                          </p>
                          <span className="badge badge-danger d-inline-flex align-items-center ms-2">
                            <i className="ti ti-clock-stop" />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="list-group-item">
                      <div className="d-flex align-items-center justify-content-between">
                        <span>Created by</span>
                        <div className="d-flex align-items-center">
                          <span className="avatar avatar-md avatar-rounded me-4">
                            <img
                              src={`${BASE_URL}/client/client/${project.client_id}/image`}
                              className="img-fluid"
                              alt="/assets/img/defaultavatar.png"
                              onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.onerror = null;
                                target.src = "/assets/img/defaultavatar.png";
                              }}
                            />
                          </span>
                          <p className="text-gray-9 mb-0">
                            {project.client_data?.username || "N/A"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="list-group-item">
                      <div className="d-flex align-items-center justify-content-between">
                        <span>Priority</span>
                        <span className="badge bg-light text-dark">
                          {project.priority}
                        </span>
                      </div>
                    </div>
                  </div>
                  <h5 className="mb-3">Tasks Details</h5>
                  <div className="bg-light p-2 rounded">
                    <span className="d-block mb-1">Tasks Done</span>
                    <h4 className="mb-2">
                      {project.Project_progress ?? 0} /{" "}
                      {project.Project_progress ?? 0}
                    </h4>
                    <div className="progress progress-xs mb-2">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width: `${project.Project_progress ?? 0}%`,
                        }}
                      />
                    </div>
                    <p>{project.Project_progress ?? 0}% Completed</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-9 col-xl-8">
              <div className="card">
                <div className="card-body">
                  <div className="bg-light rounded p-3 mb-3">
                    <div className="d-flex align-items-center">
                      <Link
                        to={all_routes.projectdetails}
                        className="flex-shrink-0 me-2"
                      >
                        <span className="avatar avatar-sm avatar-rounded me-2">
                          <img
                            src={`${BASE_URL}/project/project/${project.project_id}/image`}
                            className="img-fluid"
                            alt="/assets/img/defaultavatar.png"
                            onError={(e) => {
                              const target = e.target as HTMLImageElement;
                              target.onerror = null;
                              target.src = "/assets/img/defaultavatar.png";
                            }}
                          />
                        </span>
                      </Link>
                      <div>
                        <h6 className="mb-1">
                          <Link to={all_routes.projectdetails}>
                            {project?.project_name || "N/A"}
                          </Link>
                        </h6>
                        <p>
                          Project ID:{" "}
                          <span className="text-primary">
                            {project?.project_id || "N/A"}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-sm-3">
                      <p className="d-flex align-items-center mb-3">
                        <i className="ti ti-square-rounded me-2" />
                        Status
                      </p>
                    </div>
                    <div className="col-sm-9">
                      <span className="badge badge-soft-purple d-inline-flex align-items-center mb-3">
                        <i className="ti ti-point-filled me-1" />
                        {project?.status || "N/A"}
                      </span>
                    </div>
                    <div className="col-sm-3">
                      <p className="d-flex align-items-center mb-3">
                        <i className="ti ti-users-group me-2" />
                        Team
                      </p>
                    </div>
                    <div className="col-sm-9">
                      <div className="d-flex align-items-center mb-3 flex-wrap">
                        {projectMembers.map((id) => {
                          const emp = employeeMap?.[id];

                          if (!emp) return null;
                          return (
                            <div
                              key={id}
                              className="bg-gray-100 p-1 rounded d-flex align-items-center me-2 mb-2"
                            >
                              <div className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2">
                                <img
                                  src={`${API_BASE_PATH}/register/employee/${id}/image`}
                                  alt="/assets/img/defaultavatar.png"
                                  onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.onerror = null;
                                    target.src = "/assets/img/defaultavatar.png";
                                  }}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                              <h6 className="fs-12 mb-0">{emp.username}</h6>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    {/* Team Lead */}
                    <div className="col-sm-3">
                      <p className="d-flex align-items-center mb-3">
                        <i className="ti ti-user-shield me-2" />
                        Team Lead
                      </p>
                    </div>
                    <div className="col-sm-9">
                      <div className="d-flex align-items-center mb-3 flex-wrap">
                        {projectLeads.map((rawId) => {
                          const id = rawId.trim();
                          const emp1 = employeeMap?.[id];
                          if (!emp1) return null;

                          return (
                            <div
                              key={id}
                              className="bg-gray-100 p-1 rounded d-flex align-items-center me-2 mb-2"
                            >
                              <div className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2">
                                <img
                                  src={`${API_BASE_PATH}/register/employee/${id}/image`}
                                  alt="/assets/img/defaultavatar.png"
                                  onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.onerror = null;
                                    target.src = "/assets/img/defaultavatar.png";
                                  }}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                              <h6 className="fs-12 mb-0">{emp1.username}</h6>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    {/* Project Manager */}
                    <div className="col-sm-3">
                      <p className="d-flex align-items-center mb-3">
                        <i className="ti ti-user-star me-2" />
                        Project Manager
                      </p>
                    </div>
                    <div className="col-sm-9">
                      <div className="d-flex align-items-center mb-3 flex-wrap">
                        {projectManagers.map((rawId) => {
                          const id = rawId.trim();
                          const emp = employeeMap?.[id];
                          if (!emp) return null;

                          return (
                            <div
                              key={id}
                              className="bg-gray-100 p-1 rounded d-flex align-items-center me-2 mb-2"
                            >
                              <Link
                                to="#"
                                className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2"
                              >
                                <img
                                  src={`${API_BASE_PATH}/register/employee/${id}/image`} // ✅ Correct image URL format
                                  alt="/assets/img/defaultavatar.png"
                                  onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.onerror = null;
                                    target.src = "/assets/img/defaultavatar.png";
                                  }}// ✅ use username instead of name
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              </Link>
                              <h6 className="fs-12 mb-0">{emp.username}</h6>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    {/* <div className="col-sm-3">
                      <p className="d-flex align-items-center mb-3">
                        <i className="ti ti-bookmark me-2" />
                        Tags
                      </p>
                    </div>
                    <div className="col-sm-9">
                      <div className="d-flex align-items-center mb-3">
                        <Link
                          to="#"
                          className="badge task-tag bg-pink rounded-pill me-2"
                        >
                          Admin Panel
                        </Link>
                        <Link
                          to="#"
                          className="badge task-tag badge-info rounded-pill"
                        >
                          High Tech
                        </Link>
                      </div>
                    </div> */}
                    <div className="col-sm-12">
                      <div className="mb-3">
                        <h6 className="mb-1">Description</h6>
                        <p>{project?.description}</p>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="bg-soft-secondary p-3 rounded d-flex align-items-center justify-content-between">
                        <p className="text-secondary mb-0">
                          Time Spent on this project
                        </p>
                        <h3 className="text-secondary">
                          {project?.actual_hours}/{project?.total_hours}{" "}
                          <span className="fs-16">Hrs</span>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="custom-accordion-items">
                <div
                  className="accordion accordions-items-seperate"
                  id="accordionExample"
                >
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingTwo">
                      <div className="accordion-button">
                        <h5>Tasks</h5>
                        <div className=" ms-auto">
                          <Link
                            to="#"
                            className="d-flex align-items-center collapsed collapse-arrow"
                            data-bs-toggle="collapse"
                            data-bs-target="#primaryBorderTwo"
                            aria-expanded="false"
                            aria-controls="primaryBorderTwo"
                          >
                            <i className="ti ti-chevron-down fs-18" />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div
                      id="primaryBorderTwo"
                      className="accordion-collapse collapse show border-top"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="list-group list-group-flush">
                          {tasks.map((task) => (
                            <div
                              className="list-group-item border rounded mb-2 p-2"
                              key={task.taskId}
                            >
                              <div className="row align-items-center row-gap-3">
                                <div className="col-md-7">
                                  <div className="todo-inbox-check d-flex align-items-center flex-wrap row-gap-3">
                                    <span>
                                      <i className="ti ti-grid-dots me-2" />
                                    </span>
                                    <div className="form-check form-check-md me-2">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        defaultChecked={task.completed}
                                      />
                                    </div>
                                    <span className="me-2 d-flex align-items-center rating-select">
                                      <i className={`ti ${task.priority ? "ti-star-filled filled" : "ti-star"}`} />
                                    </span>
                                    <div className="strike-info">
                                      <h4 className="fs-14">{task.taskName}</h4>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-5">
                                  <div className="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3">
                                    <span className={`badge ${getBadgeClass(task.status)} d-inline-flex align-items-center me-3`}>
                                      <i className="fas fa-circle fs-6 me-1" />
                                      {task.status}
                                    </span>
                                    <div className="d-flex align-items-center">
                                      <div className="avatar-list-stacked avatar-group-sm">
                                        {task.assignees?.map((person, index) => (
                                          <span className="avatar avatar-rounded" key={index}>
                                            <ImageWithBasePath
                                              className="border border-white"
                                              src={person.avatar || "assets/img/profiles/default.jpg"}
                                              alt="img"
                                            />
                                          </span>
                                        ))}
                                      </div>
                                      <div className="dropdown ms-2">
                                        <Link
                                          to="#"
                                          className="d-inline-flex align-items-center"
                                          data-bs-toggle="dropdown"
                                        >
                                          <i className="ti ti-dots-vertical" />
                                        </Link>
                                        <ul className="dropdown-menu dropdown-menu-end p-3">
                                          <li>
                                            <Link
                                              to="#"
                                              className="dropdown-item rounded-1"
                                              data-bs-toggle="modal"
                                              data-inert={true}
                                              data-bs-target="#edit_todo"
                                            >
                                              <i className="ti ti-edit me-2" />
                                              Edit
                                            </Link>
                                          </li>
                                          <li>
                                            <Link
                                              to="#"
                                              className="dropdown-item rounded-1"
                                              data-bs-toggle="modal"
                                              data-inert={true}
                                              data-bs-target="#delete_modal"
                                            >
                                              <i className="ti ti-trash me-2" />
                                              Delete
                                            </Link>
                                          </li>
                                          <li>
                                            <Link
                                              to="#"
                                              className="dropdown-item rounded-1"
                                              data-bs-toggle="modal"
                                              data-inert={true}
                                              data-bs-target="#view_todo"
                                            >
                                              <i className="ti ti-eye me-2" />
                                              View
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}

                          <button
                            className="btn bg-primary-transparent border-dashed border-primary w-100 text-start"
                            data-bs-toggle="modal"
                            data-inert={true}
                            data-bs-target="#add_task"
                          >
                            <AddTaskModal />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item ">
                    <div className="accordion-header" id="headingThree">
                      <div className="accordion-button">
                        <div className="d-flex align-items-center flex-fill">
                          <h5>Images</h5>
                          <div className=" ms-auto d-flex align-items-center">
                            <Link
                              to="#"
                              className="btn btn-primary btn-xs d-inline-flex align-items-center me-3"
                            >
                              <i className="ti ti-square-rounded-plus-filled me-1" />
                              Add New
                            </Link>
                            <Link
                              to="#"
                              className="d-flex align-items-center collapsed collapse-arrow"
                              data-bs-toggle="collapse"
                              data-bs-target="#primaryBorderThree"
                              aria-expanded="false"
                              aria-controls="primaryBorderThree"
                            >
                              <i className="ti ti-chevron-down fs-18" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="primaryBorderThree"
                      className="accordion-collapse collapse show border-top"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="media-images-slider owl-carousel">
                          <Link
                            to="assets/img/media/media-big-08.jpg"
                            data-fancybox="gallery"
                            className="gallery-item"
                          >
                            <ImageWithBasePath
                              src="assets/img/media/media-08.jpg"
                              className=" rounded"
                              alt="img"
                            />
                            <div className="d-flex align-items-center hover-links">
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-maximize" />
                              </span>
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-link" />
                              </span>
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-trash" />
                              </span>
                            </div>
                          </Link>
                          <Link
                            to="assets/img/media/media-big-09.jpg"
                            data-fancybox="gallery"
                            className="gallery-item"
                          >
                            <ImageWithBasePath
                              src="assets/img/media/media-09.jpg"
                              className="rounded"
                              alt="img"
                            />
                            <div className="d-flex align-items-center hover-links">
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-maximize" />
                              </span>
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-link" />
                              </span>
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-trash" />
                              </span>
                            </div>
                          </Link>
                          <Link
                            to="assets/img/media/media-big-10.jpg"
                            data-fancybox="gallery"
                            className="gallery-item"
                          >
                            <ImageWithBasePath
                              src="assets/img/media/media-10.jpg"
                              className="rounded"
                              alt="img"
                            />
                            <div className="d-flex align-items-center hover-links">
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-maximize" />
                              </span>
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-link" />
                              </span>
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-trash" />
                              </span>
                            </div>
                          </Link>
                          <Link
                            to="assets/img/media/media-big-11.jpg"
                            data-fancybox="gallery"
                            className="gallery-item"
                          >
                            <ImageWithBasePath
                              src="assets/img/media/media-11.jpg"
                              className="rounded"
                              alt="img"
                            />
                            <div className="d-flex align-items-center hover-links">
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-maximize" />
                              </span>
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-link" />
                              </span>
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-trash" />
                              </span>
                            </div>
                          </Link>
                          <Link
                            to="assets/img/media/media-big-12.jpg"
                            data-fancybox="gallery"
                            className="gallery-item"
                          >
                            <ImageWithBasePath
                              src="assets/img/media/media-12.jpg"
                              className="rounded"
                              alt="img"
                            />
                            <div className="d-flex align-items-center hover-links">
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-maximize" />
                              </span>
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-link" />
                              </span>
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-trash" />
                              </span>
                            </div>
                          </Link>
                          <Link
                            to="assets/img/media/media-big-13.jpg"
                            data-fancybox="gallery"
                            className="gallery-item"
                          >
                            <ImageWithBasePath
                              src="assets/img/media/media-13.jpg"
                              className="rounded"
                              alt="img"
                            />
                            <div className="d-flex align-items-center hover-links">
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-maximize" />
                              </span>
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-link" />
                              </span>
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-trash" />
                              </span>
                            </div>
                          </Link>
                          <Link
                            to="assets/img/media/media-big-14.jpg"
                            data-fancybox="gallery"
                            className="gallery-item"
                          >
                            <ImageWithBasePath
                              src="assets/img/media/media-14.jpg"
                              className="rounded"
                              alt="img"
                            />
                            <div className="d-flex align-items-center hover-links">
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-maximize" />
                              </span>
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-link" />
                              </span>
                              <span className="avatar avatar-md avatar-rounded">
                                <i className="ti ti-trash" />
                              </span>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingFour">
                      <div className="accordion-button">
                        <div className="d-flex align-items-center flex-fill">
                          <h5>Files</h5>
                          <div className=" ms-auto d-flex align-items-center">
                            <Link
                              to="#"
                              className="btn btn-primary btn-xs d-inline-flex align-items-center me-3"
                            >
                              <i className="ti ti-square-rounded-plus-filled me-1" />
                              Add New
                            </Link>
                            <Link
                              to="#"
                              className="d-flex align-items-center collapsed collapse-arrow"
                              data-bs-toggle="collapse"
                              data-bs-target="#primaryBorderFour"
                              aria-expanded="false"
                              aria-controls="primaryBorderFour"
                            >
                              <i className="ti ti-chevron-down fs-18" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="primaryBorderFour"
                      className="accordion-collapse collapse show border-top"
                      aria-labelledby="headingFour"
                    >
                      <div className="accordion-body">
                        <div className="files-carousel owl-carousel">
                          <div className="card shadow-none mb-0">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
                                <div className="d-flex align-items-center">
                                  <Link
                                    to="#"
                                    className="avatar avatar-md bg-light me-2"
                                  >
                                    <ImageWithBasePath
                                      src="assets/img/icons/file-02.svg"
                                      className="w-auto h-auto"
                                      alt="img"
                                    />
                                  </Link>
                                  <div>
                                    <h6 className="mb-1">Project_1.docx</h6>
                                    <span>7.6 MB</span>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center">
                                  <Link to="#" className="btn btn-sm btn-icon">
                                    <i className="ti ti-download" />
                                  </Link>
                                  <Link to="#" className="btn btn-sm btn-icon">
                                    <i className="ti ti-trash" />
                                  </Link>
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-between">
                                <p className="fw-medium mb-0">
                                  15 May 2024, 6:53 PM
                                </p>
                                <span className="avatar avatar-sm avatar-rounded">
                                  <ImageWithBasePath
                                    src="assets/img/profiles/avatar-02.jpg"
                                    alt="Img"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="card shadow-none mb-0">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
                                <div className="d-flex align-items-center">
                                  <Link
                                    to="#"
                                    className="avatar avatar-md bg-light me-2"
                                  >
                                    <ImageWithBasePath
                                      src="assets/img/icons/file-01.svg"
                                      className="w-auto h-auto"
                                      alt="img"
                                    />
                                  </Link>
                                  <div>
                                    <h6 className="mb-1">Proposal.pdf</h6>
                                    <span>12.6 MB</span>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center">
                                  <Link to="#" className="btn btn-sm btn-icon">
                                    <i className="ti ti-download" />
                                  </Link>
                                  <Link to="#" className="btn btn-sm btn-icon">
                                    <i className="ti ti-trash" />
                                  </Link>
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-between">
                                <p className="fw-medium mb-0">
                                  15 May 2024, 6:53 PM
                                </p>
                                <span className="avatar avatar-sm avatar-rounded">
                                  <ImageWithBasePath
                                    src="assets/img/users/user-19.jpg"
                                    alt="Img"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="card shadow-none mb-0">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
                                <div className="d-flex align-items-center">
                                  <Link
                                    to="#"
                                    className="avatar avatar-md bg-light me-2"
                                  >
                                    <ImageWithBasePath
                                      src="assets/img/icons/file-04.svg"
                                      className="w-auto h-auto"
                                      alt="img"
                                    />
                                  </Link>
                                  <div>
                                    <h6 className="mb-1">Logo-Img.zip</h6>
                                    <span>6.2 MB</span>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center">
                                  <Link to="#" className="btn btn-sm btn-icon">
                                    <i className="ti ti-download" />
                                  </Link>
                                  <Link to="#" className="btn btn-sm btn-icon">
                                    <i className="ti ti-trash" />
                                  </Link>
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-between">
                                <p className="fw-medium mb-0">
                                  15 May 2024, 6:53 PM
                                </p>
                                <span className="avatar avatar-sm avatar-rounded">
                                  <ImageWithBasePath
                                    src="assets/img/users/user-20.jpg"
                                    alt="Img"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-6 d-flex">
                      <div className="accordion-item flex-fill">
                        <div className="accordion-header" id="headingFive">
                          <div className="accordion-button">
                            <div className="d-flex align-items-center flex-fill">
                              <h5>Notes</h5>
                              <div className=" ms-auto d-flex align-items-center">
                                <Link
                                  to="#"
                                  className="btn btn-primary btn-xs d-inline-flex align-items-center me-3"
                                >
                                  <i className="ti ti-square-rounded-plus-filled me-1" />
                                  Add New
                                </Link>
                                <Link
                                  to="#"
                                  className="d-flex align-items-center collapsed collapse-arrow"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#primaryBorderFive"
                                  aria-expanded="false"
                                  aria-controls="primaryBorderFive"
                                >
                                  <i className="ti ti-chevron-down fs-18" />
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="primaryBorderFive"
                          className="accordion-collapse collapse show border-top"
                          aria-labelledby="headingFive"
                        >
                          <div className="accordion-body">
                            <div className="card">
                              <div className="card-body">
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                  <h6 className="text-gray-5 fw-medium">
                                    15 May 2025
                                  </h6>
                                  <div className="dropdown">
                                    <Link
                                      to="#"
                                      className="d-inline-flex align-items-center"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i className="ti ti-dots-vertical" />
                                    </Link>
                                    <ul className="dropdown-menu dropdown-menu-end p-3">
                                      <li>
                                        <Link
                                          to="#"
                                          className="dropdown-item rounded-1"
                                        >
                                          <i className="ti ti-edit me-2" />
                                          Edit
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to="#"
                                          className="dropdown-item rounded-1"
                                        >
                                          <i className="ti ti-trash me-1" />
                                          Delete
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <h6 className="d-flex align-items-center mb-2">
                                  <i className="ti ti-point-filled text-primary me-1" />
                                  Changes &amp; design
                                </h6>
                                <p className="text-truncate line-clamb-3">
                                  An office management app project streamlines
                                  administrative tasks by integrating tools for
                                  scheduling, communication, and task
                                  management, enhancing overall productivity and
                                  efficiency.
                                </p>
                              </div>
                            </div>
                            <div className="card mb-0">
                              <div className="card-body">
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                  <h6 className="text-gray-5 fw-medium">
                                    15 May 2025
                                  </h6>
                                  <div className="dropdown">
                                    <Link
                                      to="#"
                                      className="d-inline-flex align-items-center"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i className="ti ti-dots-vertical" />
                                    </Link>
                                    <ul className="dropdown-menu dropdown-menu-end p-3">
                                      <li>
                                        <Link
                                          to="#"
                                          className="dropdown-item rounded-1"
                                        >
                                          <i className="ti ti-edit me-2" />
                                          Edit
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to="#"
                                          className="dropdown-item rounded-1"
                                        >
                                          <i className="ti ti-trash me-1" />
                                          Delete
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <h6 className="d-flex align-items-center mb-2">
                                  <i className="ti ti-point-filled text-primary me-1" />
                                  Changes &amp; design
                                </h6>
                                <p className="text-truncate line-clamb-3">
                                  An office management app project streamlines
                                  administrative tasks by integrating tools for
                                  scheduling, communication, and task
                                  management, enhancing overall productivity and
                                  efficiency.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 d-flex">
                      <div className="accordion-item flex-fill">
                        <div className="accordion-header" id="headingSix">
                          <div className="accordion-button">
                            <div className="d-flex align-items-center flex-fill">
                              <h5>Activity</h5>
                              <div className=" ms-auto d-flex align-items-center">
                                <Link
                                  to="#"
                                  className="btn btn-primary btn-xs d-inline-flex align-items-center me-3"
                                >
                                  <i className="ti ti-square-rounded-plus-filled me-1" />
                                  Add New
                                </Link>
                                <Link
                                  to="#"
                                  className="d-flex align-items-center collapsed collapse-arrow"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#primaryBorderSix"
                                  aria-expanded="false"
                                  aria-controls="primaryBorderSix"
                                >
                                  <i className="ti ti-chevron-down fs-18" />
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="primaryBorderSix"
                          className="accordion-collapse collapse show border-top"
                          aria-labelledby="headingSix"
                        >
                          <div className="accordion-body">
                            <div className="notice-widget">
                              <div className="d-flex align-items-center justify-content-between mb-4">
                                <div className="d-flex overflow-hidden">
                                  <span className="bg-info avatar avatar-md me-3 rounded-circle flex-shrink-0">
                                    <i className="ti ti-checkup-list fs-16" />
                                  </span>
                                  <div className="overflow-hidden">
                                    <p className="text-truncate mb-1">
                                      <span className="text-gray-9 fw-medium">
                                        Andrew
                                      </span>
                                      added a New Task
                                    </p>
                                    <p className="mb-1">15 May 2024, 6:53 PM</p>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-between mb-4">
                                <div className="d-flex overflow-hidden me-2">
                                  <span className="bg-warning avatar avatar-md me-3 rounded-circle flex-shrink-0">
                                    <i className="ti ti-circle-dot fs-16" />
                                  </span>
                                  <div className="overflow-hidden">
                                    <p className="text-truncate mb-1">
                                      <span className="text-gray-9 fw-medium">
                                        Jermai{" "}
                                      </span>
                                      Moved task{" "}
                                      <span className="text-gray-9 fw-medium">
                                        {" "}
                                        “Private chat module”
                                      </span>
                                    </p>
                                    <p className="mb-1">15 May 2024, 6:53 PM</p>
                                    <div className="d-flex align-items-center">
                                      <span className="badge badge-success me-2">
                                        <i className="ti ti-point-filled me-1" />
                                        Completed
                                      </span>
                                      <span>
                                        <i className="ti ti-arrows-left-right me-2" />
                                      </span>
                                      <span className="badge badge-purple">
                                        <i className="ti ti-point-filled me-1" />
                                        Inprogress
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-between mb-4">
                                <div className="d-flex overflow-hidden me-2">
                                  <span className="bg-purple avatar avatar-md me-3 rounded-circle flex-shrink-0">
                                    <i className="ti ti-checkup-list fs-16" />
                                  </span>
                                  <div className="overflow-hidden">
                                    <p className="text-truncate mb-1">
                                      <span className="text-gray-9 fw-medium">
                                        Jermai{" "}
                                      </span>
                                      Created task{" "}
                                      <span className="text-gray-9 fw-medium">
                                        {" "}
                                        “Private chat module”
                                      </span>
                                    </p>
                                    <p className="mb-1">15 May 2024, 6:53 PM</p>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex overflow-hidden">
                                  <span className="bg-secondary avatar avatar-md me-3 rounded-circle flex-shrink-0">
                                    <i className="ti ti-photo fs-16" />
                                  </span>
                                  <div className="overflow-hidden">
                                    <p className="text-truncate mb-1">
                                      <span className="text-gray-9 fw-medium">
                                        Hendry
                                      </span>{" "}
                                      Updated Image{" "}
                                      <span className="text-gray-9 fw-medium">
                                        {" "}
                                        “logo.jpg”{" "}
                                      </span>
                                    </p>
                                    <p className="mb-1">15 May 2024, 6:53 PM</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingSeven">
                      <div className="accordion-button">
                        <h5>Invoices</h5>
                        <div className=" ms-auto d-flex align-items-center">
                          <Link
                            to="#"
                            className="d-flex align-items-center collapsed collapse-arrow"
                            data-bs-toggle="collapse"
                            data-bs-target="#primaryBorderSeven"
                            aria-expanded="false"
                            aria-controls="primaryBorderSeven"
                          >
                            <i className="ti ti-chevron-down fs-18" />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div
                      id="primaryBorderSeven"
                      className="accordion-collapse collapse show border-top"
                      aria-labelledby="headingSeven"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="list-group list-group-flush">
                          <div className="list-group-item border rounded mb-2 p-2">
                            <div className="row align-items-center g-3">
                              <div className="col-sm-6">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avatar-lg bg-light flex-shrink-0 me-2">
                                    <i className="ti ti-file-invoice text-dark fs-24" />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1">
                                      Phase 2 Completion
                                    </h6>
                                    <p>
                                      <Link to="#" className="text-info">
                                        #INV-123{" "}
                                      </Link>{" "}
                                      11 Sep 2025, 05:35 pm
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-3">
                                <div>
                                  <span>Amount</span>
                                  <p className="text-dark">$6,598</p>
                                </div>
                              </div>
                              <div className="col-sm-3">
                                <div className="d-flex align-items-center justify-content-sm-end">
                                  <span className="badge badge-soft-success d-inline-flex  align-items-center me-4">
                                    <i className="ti ti-point-filled me-1" />
                                    Paid
                                  </span>
                                  <Link to="#" className="btn btn-icon btn-sm">
                                    <i className="ti ti-edit" />
                                  </Link>
                                  <Link to="#" className="btn btn-icon btn-sm ">
                                    <i className="ti ti-trash" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="list-group-item border rounded mb-2 p-2">
                            <div className="row align-items-center g-3">
                              <div className="col-sm-6">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avatar-lg bg-light flex-shrink-0 me-2">
                                    <i className="ti ti-file-invoice text-dark fs-24" />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1">
                                      Advance for Project
                                    </h6>
                                    <p>
                                      <Link to="#" className="text-info">
                                        #INV-124{" "}
                                      </Link>{" "}
                                      14 Sep 2025, 05:35 pm
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-3">
                                <div>
                                  <span>Amount</span>
                                  <p className="text-dark">$3312</p>
                                </div>
                              </div>
                              <div className="col-sm-3">
                                <div className="d-flex align-items-center justify-content-sm-end">
                                  <span className="badge badge-soft-success d-inline-flex  align-items-center me-4">
                                    <i className="ti ti-point-filled me-1" />
                                    Hold
                                  </span>
                                  <Link to="#" className="btn btn-icon btn-sm">
                                    <i className="ti ti-edit" />
                                  </Link>
                                  <Link to="#" className="btn btn-icon btn-sm ">
                                    <i className="ti ti-trash" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="list-group-item border rounded mb-2 p-2">
                            <div className="row align-items-center g-3">
                              <div className="col-sm-6">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avatar-lg bg-light flex-shrink-0 me-2">
                                    <i className="ti ti-file-invoice text-dark fs-24" />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1">
                                      Changes &amp; design Alignments
                                    </h6>
                                    <p>
                                      <Link to="#" className="text-info">
                                        #INV-125{" "}
                                      </Link>{" "}
                                      15 Sep 2025, 05:35 pm
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-3">
                                <div>
                                  <span>Amount</span>
                                  <p className="text-dark">$4154</p>
                                </div>
                              </div>
                              <div className="col-sm-3">
                                <div className="d-flex align-items-center justify-content-sm-end">
                                  <span className="badge badge-soft-success d-inline-flex  align-items-center me-4">
                                    <i className="ti ti-point-filled me-1" />
                                    Paid
                                  </span>
                                  <Link to="#" className="btn btn-icon btn-sm">
                                    <i className="ti ti-edit" />
                                  </Link>
                                  <Link to="#" className="btn btn-icon btn-sm ">
                                    <i className="ti ti-trash" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="list-group-item border rounded mb-2 p-2">
                            <div className="row align-items-center g-3">
                              <div className="col-sm-6">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avatar-lg bg-light flex-shrink-0 me-2">
                                    <i className="ti ti-file-invoice text-dark fs-24" />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1">
                                      Added New Functionality
                                    </h6>
                                    <p>
                                      <Link to="#" className="text-info">
                                        #INV-126{" "}
                                      </Link>{" "}
                                      16 Sep 2025, 05:35 pm
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-3">
                                <div>
                                  <span>Amount</span>
                                  <p className="text-dark">$658</p>
                                </div>
                              </div>
                              <div className="col-sm-3">
                                <div className="d-flex align-items-center justify-content-sm-end">
                                  <span className="badge badge-soft-success d-inline-flex  align-items-center me-4">
                                    <i className="ti ti-point-filled me-1" />
                                    Paid
                                  </span>
                                  <Link to="#" className="btn btn-icon btn-sm">
                                    <i className="ti ti-edit" />
                                  </Link>
                                  <Link to="#" className="btn btn-icon btn-sm ">
                                    <i className="ti ti-trash" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="list-group-item border rounded p-2">
                            <div className="row align-items-center g-3">
                              <div className="col-sm-6">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avatar-lg bg-light flex-shrink-0 me-2">
                                    <i className="ti ti-file-invoice text-dark fs-24" />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1">
                                      Phase 1 Completion
                                    </h6>
                                    <p>
                                      <Link to="#" className="text-info">
                                        #INV-127{" "}
                                      </Link>{" "}
                                      17 Sep 2025, 05:35 pm
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-3">
                                <div>
                                  <span>Amount</span>
                                  <p className="text-dark">$1259</p>
                                </div>
                              </div>
                              <div className="col-sm-3">
                                <div className="d-flex align-items-center justify-content-sm-end">
                                  <span className="badge badge-soft-danger d-inline-flex  align-items-center me-4">
                                    <i className="ti ti-point-filled me-1" />
                                    unpaid
                                  </span>
                                  <Link to="#" className="btn btn-icon btn-sm">
                                    <i className="ti ti-edit" />
                                  </Link>
                                  <Link to="#" className="btn btn-icon btn-sm ">
                                    <i className="ti ti-trash" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-end mb-4">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="d-inline-flex align-items-center avatar avatar-lg avatar-rounded bg-primary"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-plus fs-24 text-white" />
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end bg-gray-900 dropdown-menu-md dropdown-menu-dark p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1 d-flex align-items-center"
                        >
                          <span className="avatar avatar-md bg-gray-800 flex-shrink-0 me-2">
                            <i className="ti ti-basket-code" />
                          </span>
                          <div>
                            <h6 className="fw-medium text-white mb-1">
                              Add a Task
                            </h6>
                            <p className="text-white">
                              Create a new Priority tasks{" "}
                            </p>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1 d-flex align-items-center"
                        >
                          <span className="avatar avatar-md bg-gray-800 flex-shrink-0 me-2">
                            <i className="ti ti-file-invoice" />
                          </span>
                          <div>
                            <h6 className="fw-medium text-white mb-1">
                              Add Invoice
                            </h6>
                            <p className="text-white">Create a new Billing</p>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1 d-flex align-items-center"
                        >
                          <span className="avatar avatar-md bg-gray-800 flex-shrink-0 me-2">
                            <i className="ti ti-file-description" />
                          </span>
                          <div>
                            <h6 className="fw-medium text-white mb-1">Notes</h6>
                            <p className="text-white">
                              Create new note for you &amp; team
                            </p>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1 d-flex align-items-center"
                        >
                          <span className="avatar avatar-md bg-gray-800 flex-shrink-0 me-2">
                            <i className="ti ti-folder-open" />
                          </span>
                          <div>
                            <h6 className="fw-medium text-white mb-1">
                              Add Files
                            </h6>
                            <p className="text-white">
                              Upload New files for this Client
                            </p>
                          </div>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025 © IATT.</p>
          <p>
            Designed &amp; Developed By{" "}
            <Link to="#" className="text-primary">
              IATT
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      {/* Edit Project */}
      <div className="modal fade" id="edit_project" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header header-border align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <h5 className="modal-title me-2">Edit Project</h5>
                <p className="text-dark">Project ID: {project?.project_id}</p>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <div className="add-info-fieldset">
              <div className="contact-grids-tab p-3 pb-0">
                <ul className="nav nav-underline" id="myTabEdit" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="basic-tab-edit"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info-edit"
                      type="button"
                      role="tab"
                    >
                      Basic Information
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="member-tab-edit"
                      data-bs-toggle="tab"
                      data-bs-target="#member-edit"
                      type="button"
                      role="tab"
                    >
                      Members
                    </button>
                  </li>
                </ul>
              </div>

              <div className="tab-content" id="myTabContentEdit">
                {/* ✅ Basic Information Tab */}
                <div
                  className="tab-pane fade show active"
                  id="basic-info-edit"
                  role="tabpanel"
                  aria-labelledby="basic-tab-edit"
                >
                  <form>
                    <div className="modal-body">
                      <div className="row">
                        {/* Project Logo Upload */}
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Project Logo</label>
                          <div className="d-flex align-items-center">
                            <div className="avatar avatar-xxl rounded-circle border border-dashed me-3">
                              {imagePreview ? (
                                <img
                                  src={imagePreview}
                                  alt="Preview"
                                  className="rounded-circle"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <i className="ti ti-photo fs-24 text-gray-3" />
                              )}
                            </div>
                            <div>
                              <div className="btn btn-sm btn-primary position-relative overflow-hidden">
                                Upload
                                <input
                                  type="file"
                                  accept="image/*"
                                  className="form-control position-absolute start-0 top-0 opacity-0 w-100 h-100"
                                  onChange={handleLogoChange}
                                />
                              </div>
                              {imagePreview && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-light ms-2"
                                  onClick={handleCancel}
                                >
                                  Cancel
                                </button>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Project Name */}
                        <div className="col-md-12 mb-3">
                          <label className="form-label">Project Name</label>
                          <input
                            type="text"
                            className="form-control"
                            value={projectName}
                            onChange={(e) => setProjectName(e.target.value)}
                          />
                        </div>

                        {/* Client */}
                        <div className="col-md-12 mb-3">
                          <label className="form-label">Client</label>
                          <input
                            type="text"
                            className="form-control"
                            value={project.client_data?.username}
                            disabled // 👈 makes it non-editable
                            onChange={(e) => setProjectName(e.target.value)}
                          />
                        </div>

                        {/* Dates */}
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Start Date</label>
                          <DatePicker
                            className="form-control"
                            value={startDate ? dayjs(startDate) : null}
                            onChange={(date) =>
                              setStartDate(date?.toISOString() || "")
                            }
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="form-label">End Date</label>
                          <DatePicker
                            className="form-control"
                            value={endDate ? dayjs(endDate) : null}
                            onChange={(date) =>
                              setEndDate(date?.toISOString() || "")
                            }
                          />
                        </div>

                        {/* Priority */}
                        <div className="col-md-4 mb-3">
                          <label className="form-label">Priority</label>
                          <input
                            type="text"
                            className="form-control"
                            value={priority}
                            onChange={(e) => setPriority(e.target.value)}
                          />
                        </div>

                        {/* Value / Price Type */}
                        <div className="col-md-4 mb-3">
                          <label className="form-label">Project Value</label>
                          <input
                            type="number"
                            className="form-control"
                            value={projectValue}
                            onChange={(e) => setProjectValue(e.target.value)}
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label">Price Type</label>
                          <input
                            type="text"
                            className="form-control"
                            value={priceType}
                            onChange={(e) => setPriceType(e.target.value)}
                          />
                        </div>

                        {/* Description */}
                        <div className="col-md-12 mb-3">
                          <label className="form-label">Description</label>
                          {/* <CommonTextEditor ref={descriptionRef} /> */}
                          <input
                            type="text-area"
                            className="form-control"
                            value={project?.description}
                            disabled // 👈 makes it non-editable
                            onChange={(e) => setProjectName(e.target.value)}
                          />
                        </div>

                        {/* File Upload */}
                        <div className="col-md-12 mb-3">
                          <label className="form-label">Upload File</label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={(e) =>
                              setUploadFile(e.target.files?.[0] || null)
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() =>
                          document.getElementById("member-tab-edit")?.click()
                        }
                      >
                        Next
                      </button>
                    </div>
                  </form>
                </div>

                {/* ✅ Members Tab */}
                <div
                  className="tab-pane fade"
                  id="member-edit"
                  role="tabpanel"
                  aria-labelledby="member-tab-edit"
                >
                  <form>
                    <div className="modal-body">
                      <div className="row">
                        {/* ✅ Team Members */}
                        <div className="col-md-12 mb-3">
                          <label className="form-label">Team Members</label>
                          <Select
                            isMulti
                            options={employeeOptions}
                            value={teamMembers}
                            onChange={handleMultiSelect(setTeamMembers)}
                          />
                        </div>

                        {/* ✅ Team Leader */}
                        <div className="col-md-12 mb-3">
                          <label className="form-label">Team Leader</label>
                          <Select
                            isMulti
                            options={employeeOptions}
                            value={teamLeader}
                            onChange={handleMultiSelect(setTeamLeader)}
                          />
                        </div>

                        {/* ✅ Project Manager */}
                        <div className="col-md-12 mb-3">
                          <label className="form-label">Project Manager</label>
                          <Select
                            isMulti
                            options={employeeOptions}
                            value={projectManager}
                            onChange={handleMultiSelect(setProjectManager)}
                          />
                        </div>

                        {/* Tags */}
                        <div className="col-md-12 mb-3">
                          <label className="form-label">Tags</label>
                          <CommonTagsInput value={tags} onChange={setTags} />
                        </div>

                        {/* Status */}
                        <div className="col-md-12 mb-3">
                          <label className="form-label">Status</label>
                          <Select
                            options={statusOptions}
                            value={statusOptions.find(
                              (opt) => opt.value === statusVal
                            )}
                            onChange={handleSingleSelect(setStatusVal)}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary"
                        type="button"
                        onClick={handleEditSubmit}
                        data-bs-dismiss="modal"
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Project */}

      {/* Todo Details */}
      <div className="modal fade" id="view_todo">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-dark">
              <h4 className="modal-title text-white">
                Respond to any pending messages
              </h4>
              <span className="badge badge-danger d-inline-flex align-items-center">
                <i className="ti ti-square me-1" />
                Urgent
              </span>
              <span>
                <i className="ti ti-star-filled text-warning" />
              </span>
              <Link to="#">
                <i className="ti ti-trash text-white" />
              </Link>
              <button
                type="button"
                className="btn-close custom-btn-close bg-transparent fs-16 text-white position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <h5 className="mb-2">Task Details</h5>
              <div className="border rounded mb-3 p-2">
                <div className="row row-gap-3">
                  <div className="col-md-4">
                    <div className="text-center">
                      <span className="d-block mb-1">Created On</span>
                      <p className="text-dark">22 July 2025</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="text-center">
                      <span className="d-block mb-1">Due Date</span>
                      <p className="text-dark">22 July 2025</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="text-center">
                      <span className="d-block mb-1">Status</span>
                      <span className="badge badge-soft-success d-inline-flex align-items-center">
                        <i className="fas fa-circle fs-6 me-1" />
                        Completed
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <h5 className="mb-2">Description</h5>
                <p>
                  Hiking is a long, vigorous walk, usually on trails or
                  footpaths in the countryside. Walking for pleasure developed
                  in Europe during the eighteenth century. Religious pilgrimages
                  have existed much longer but they involve walking long
                  distances for a spiritual purpose associated with specific
                  religions and also we achieve inner peace while we hike at a
                  local park.
                </p>
              </div>
              <div className="mb-3">
                <h5 className="mb-2">Tags</h5>
                <div className="d-flex align-items-center">
                  <span className="badge badge-danger me-2">Internal</span>
                  <span className="badge badge-success me-2">Projects</span>
                  <span className="badge badge-secondary">Reminder</span>
                </div>
              </div>
              <div>
                <h5 className="mb-2">Assignee</h5>
                <div className="avatar-list-stacked avatar-group-sm">
                  <span className="avatar avatar-rounded">
                    <ImageWithBasePath
                      className="border border-white"
                      src="assets/img/profiles/avatar-23.jpg"
                      alt="img"
                    />
                  </span>
                  <span className="avatar avatar-rounded">
                    <ImageWithBasePath
                      className="border border-white"
                      src="assets/img/profiles/avatar-24.jpg"
                      alt="img"
                    />
                  </span>
                  <span className="avatar avatar-rounded">
                    <ImageWithBasePath
                      className="border border-white"
                      src="assets/img/profiles/avatar-25.jpg"
                      alt="img"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Todo Details */}
    </>
  );
};

export default ProjectDetails;
